// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "blocked_time_exception".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "blocked_time_exception" table (1:1 with a DB row, on the wire). */
export const blockedTimeExceptionAtomSchema = z.object({
    id: z.string(),
    blockedTimeId: z.string(),
    originalStart: z.string().datetime(),
    cancelled: z.boolean(),
    startDate: z.string().datetime().nullable(),
    endDate: z.string().datetime().nullable(),
    title: z.string().nullable(),
    description: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=blockedTimeException.js.map